import type { LeaveTypesRepositoryT } from "../../domain/ports/leaveTypes.repository";

type GetLeaveTypesParamsT = {
  leaveTypesRepository: LeaveTypesRepositoryT;
  colaboraInstanceId: string;
};

export const getLeaveTypes = async ({
  leaveTypesRepository,
  colaboraInstanceId,
}: GetLeaveTypesParamsT) => {
  return await leaveTypesRepository.getAll(colaboraInstanceId);
};
